module.exports = __webpack_public_path__ + "img/iteration.7e56e8f9.png";